import React from 'react';
import {
  AddStrongIcon,
  ContentStrongIcon,
  LinkStrongIcon,
  PhotoPlusStrongIcon,
  TextStrongIcon,
  UploadStrongIcon,
} from 'src/monet/icons';
import { BlockPlaceholderType } from '../types';

export function PlaceHolderIcon({
  blockPlaceholderType,
  className,
}: {
  blockPlaceholderType: BlockPlaceholderType;
  className?: string;
}) {
  let IconComponent = null;
  if (blockPlaceholderType === 'upload-file') {
    IconComponent = UploadStrongIcon;
  } else if (blockPlaceholderType === 'add-content') {
    IconComponent = AddStrongIcon;
  } else if (blockPlaceholderType === 'pick-widget') {
    IconComponent = ContentStrongIcon;
  } else if (blockPlaceholderType === 'write-something') {
    IconComponent = TextStrongIcon;
  } else if (blockPlaceholderType === 'add-image-by-url') {
    IconComponent = LinkStrongIcon;
  } else if (blockPlaceholderType === 'add-image') {
    IconComponent = PhotoPlusStrongIcon;
  } else if (blockPlaceholderType === 'add-embed') {
    IconComponent = LinkStrongIcon;
  }
  return IconComponent ? <IconComponent className={className} /> : null;
}
export function toPlaceHolderLabel(blockPlaceholderType: BlockPlaceholderType) {
  if (blockPlaceholderType === 'upload-file') {
    return 'Upload file';
  } else if (blockPlaceholderType === 'add-content') {
    return 'Add content';
  } else if (blockPlaceholderType === 'pick-widget') {
    return 'Pick widget';
  } else if (blockPlaceholderType === 'write-something') {
    return 'Write something';
  } else if (blockPlaceholderType === 'add-image-by-url') {
    return 'Add image url';
  } else if (blockPlaceholderType === 'add-image') {
    return 'Add image';
  } else if (blockPlaceholderType === 'add-embed') {
    return 'Add web embed';
  }
}
